export default __webpack_public_path__ + "static/Cactus_Sap-3c2541243484d3b4a202de5ac4e09122.png";